import { React, styled, useNavigate } from '../lib/imports';
import { Button, Text } from '../components';
import { useSelector, useDispatch } from 'react-redux';
import { setHeatStreakPanelToOpen } from '../ui/actions';
import { ButtonContainer } from './styled/ButtonContainer';
import { Description } from './styled/Description';
import { useCdnUrl } from '../app/context/config';

const cdnUrl = useCdnUrl();

const ComingSoonContainer = styled('div')`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.black};
  justify-content: flex-start;
  align-items: center;
  padding: 18px 40px 30px 40px;
  p {
    color: ${({ theme }) => theme.colors.white};
  }
  button {
    margin-top: 10px;
    margin-bottom: 70px;
  }
`;

const ImageContainer = styled('img')`
  height: 250px;
  margin-bottom: 21px;
`;

const ComingSoon = () => {
  const { strings } = useSelector((state) => state);
  const comingSoonAssetSrc = `${cdnUrl}2025-2026_stanley_cup.png`;
  const comingSoonTitle = strings['leaderboard/playoffs/coming-soon/title'];
  const comingSoonText = strings['leaderboard/playoffs/coming-soon/text'];
  const comingSoonbtn1 = strings['leaderboard/playoffs/coming-soon/btn1'];
  const comingSoonbtn2 = strings['leaderboard/playoffs/coming-soon/btn2'];
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleHeatStreakPanelClick = () => {
    return dispatch(setHeatStreakPanelToOpen());
  };

  return (
    <ComingSoonContainer>
      <ImageContainer src={comingSoonAssetSrc} />
      <Text size='peta' centered heading bold>
        {comingSoonTitle}
      </Text>
      <Description size='tera' centered style={{ padding: '0 0 12px 0' }}>
        {comingSoonText}
      </Description>
      <ButtonContainer>
        <Button
          size='peta'
          variant='primary'
          style={{ padding: '12px 16px', width: '100%', fontSize: '18px', marginBottom: '0' }}
          onSelect={() => {
            navigate('/');
          }}
          stretch
        >
          {comingSoonbtn1}
        </Button>
        <Button
          size='peta'
          variant='primary'
          style={{ padding: '12px 16px', width: '100%', fontSize: '18px' }}
          onSelect={handleHeatStreakPanelClick}
          stretch
        >
          {comingSoonbtn2}
        </Button>
      </ButtonContainer>
    </ComingSoonContainer>
  );
};

export default ComingSoon;
